import { render, staticRenderFns } from "./ProjectsAutocomplete.vue?vue&type=template&id=2f5e45e9&"
import script from "./ProjectsAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ProjectsAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsAutocomplete.vue?vue&type=style&index=0&id=2f5e45e9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports